angular.module('impactx.message').controller('MessageTodoListCtrl', ['$scope', '$rootScope', 'dataGen', '$route', 'ToastService', '$redirect', 'selectedListItems', 'ListSelection', 'ConfirmationService', 'TranslationService', MessageTodoListCtrl]);

function MessageTodoListCtrl($scope, $rootScope, dataGen, $route, ToastService, $redirect, selectedListItems, ListSelection, ConfirmationService, TranslationService) {

    var ctrl = this;

    ctrl.getDetailsLink = function () {
        return "message/" + selectedListItems.getFirstSelectedId();
    };

    var anyNotOpenToDoMulti = function () {
        var selectedItems = selectedListItems.getSelectedItems();
        for (let i = 0; i < selectedItems.length; i++) {
            if (!selectedItems[i].openTodo.value) {
                return true; // if any selected message does not have a open tdo
            }
        }
        return false;
    };

    ctrl.canFollowMessageLink = function () {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().openTodo.value
            && selectedListItems.getFirstSelectedItem().route;
    };

    ctrl.canDelete = function () {
        return anyNotOpenToDoMulti();
    };

    ctrl.canDeleteAll = function() {
        return !selectedListItems.isAnySelected() && selectedListItems.rowCount > 0;
    };

    ctrl.delete = function () {
        deleteRequest(selectedListItems.getSelectedIds());
    };

    ctrl.deleteAll = function (event) {
        ListSelection.getAllListIds(ctrl.getMeta().params.listConfig, '/message/list/ids').then(function (listIds) {
            ConfirmationService.showConfirmationDialog(function () {
                    deleteRequest(listIds);
                }, event, TranslationService.get('deleteQuestion').replace('^0', listIds.length),
                TranslationService.get('delete'), TranslationService.get('abort'));
        });
    };

    function deleteRequest(ids) {
        var selectedItems = selectedListItems.getSelectedItems();

        dataGen.postAsForm({}, {ids: ids}, "/message/delete").then(function () {
            selectedListItems.unselectAll(selectedItems);
            $rootScope.$broadcast('list:resetPageSelection');
            $route.reload();
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    }

    ctrl.followMessageLink = function () {
        let id = selectedListItems.getFirstSelectedId();
        let route = selectedListItems.getFirstSelectedItem().route;
        if (route) {
            var dataObj = {
                ids: [id]
            };
            dataGen.postAsForm({}, dataObj, '/message/markread').then(function () {
                $redirect.redirectTo(null, route);
            });
        }
    };

    ctrl.canMarkRead = function() {
        return selectedListItems.getSelectedItems().length > 0;
    };

    ctrl.canMarkReadAll = function() {
        return !selectedListItems.isAnySelected() && selectedListItems.rowCount > 0;
    };

    ctrl.canMarkDone = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().openTodo.value;
    };

    ctrl.markRead = function () {
        markReadRequest(selectedListItems.getSelectedIds());
    };

    ctrl.markReadAll = function (event) {
        ListSelection.getAllListIds(ctrl.getMeta().params.listConfig, '/message/list/ids').then(function (listIds) {
            ConfirmationService.showConfirmationDialog(function () {
                    markReadRequest(listIds);
                }, event, TranslationService.get('markReadQuestion').replace('^0', listIds.length),
                TranslationService.get('markRead'), TranslationService.get('abort'));
        });
    };

    function markReadRequest(ids) {
        var selectedItems = selectedListItems.getSelectedItems();

        dataGen.postAsForm({}, {ids: ids}, "/message/markread").then(function () {
            selectedListItems.unselectAll(selectedItems);
            $rootScope.$broadcast('list:resetPageSelection');
            $route.reload();
            ToastService.openStandardToast(TranslationService.get('markReadSuccess'));
        });
    }

    ctrl.markDone = function(event, trns) {
        var selectedItems = selectedListItems.getSelectedItems();

        ConfirmationService.showConfirmationDialog(function () {
                dataGen.postAsForm({}, {mesId: selectedListItems.getFirstSelectedId()}, "/message/markdone").then(function () {
                    selectedListItems.unselectAll(selectedItems);
                    $rootScope.$broadcast('list:resetPageSelection');
                    $route.reload();
                    ToastService.openStandardToast(trns.markDoneSuccess);
                });
            },
            event,
            trns.markDone,
            TranslationService.get('ok'),
            TranslationService.get('abort'),
            trns.markDoneQuestion
        );
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: ctrl.getDetailsLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'Message'
        },
        {label: "edit", action: ctrl.followMessageLink, condition: ctrl.canFollowMessageLink},
        {label: "markRead", action: ctrl.markRead, condition: ctrl.canMarkRead, process: 'Message'},
        {label: "markReadAll", action: ctrl.markReadAll, condition: ctrl.canMarkReadAll, process: 'Message'},
        {label: "markDone", action: ctrl.markDone, condition: ctrl.canMarkDone, process: 'Message'},
        {label: "delete", action: ctrl.delete, condition: ctrl.canDelete, process: 'Message'},
        {label: "deleteAll", action: ctrl.deleteAll, condition: ctrl.canDeleteAll, process: 'Message'}
    ];

    ctrl.meta = {
        rowTemplate: 'modules/message/templates/messagelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/message/list/todo',
        id: "messagetodolist",
        idColumn: "id",
        buttonDefinition: buttonDefinition,
        printEndpoint: '/message/list/excel'
    };
    ctrl.getMeta = function () {
        return ctrl.meta;
    };
}

